import React from 'react';
import { motion } from 'framer-motion';
export function TomosGrid() {
  const tomos = [{
    id: 1,
    color: 'bg-forest',
    lightColor: 'bg-forest/10',
    borderColor: 'border-forest/20',
    textColor: 'text-forest-dark',
    emoji: '⛏️',
    title: 'Fundamentos de la Minería',
    subtitle: 'Historia, ciclo de vida, minerales estratégicos, provincias mineras y recursos vs. reservas. Todo el contexto argentino que necesitás para hablar con autoridad desde el primer día.',
    desc: 'Resultado: Tus alumnos entienden por qué el litio, el cobre y el oro argentino importan en el mundo real.\n\nHISTORIA MINERA · PROVINCIAS MINERAS · LITIO · COBRE · ORO · CICLO DE VIDA · ARGENTINA MINERA'
  }, {
    id: 2,
    color: 'bg-earth',
    lightColor: 'bg-earth/10',
    borderColor: 'border-earth/20',
    textColor: 'text-earth',
    emoji: '🪨',
    title: 'Geología Aplicada a la Minería',
    subtitle: 'Mineralogía, petrología, geología estructural, tectónica de placas y cartografía con mapas reales del SEGEMAR. Explicás por qué el litio está en la Puna y el cobre en los Andes.',
    desc: 'Resultado: Cada clase de geología tiene ejemplos del subsuelo argentino real, no de manuales genéricos.\n\nMINERALOGÍA · DANA · PETROLOGÍA · GEOLOGÍA ESTRUCTURAL · MAPAS SEGEMAR · YACIMIENTOS ARGENTINOS'
  }, {
    id: 3,
    color: 'bg-gold',
    lightColor: 'bg-gold/10',
    borderColor: 'border-gold/20',
    textColor: 'text-gold-dark',
    emoji: '🚜',
    title: 'Explotación Minera',
    subtitle: 'Cielo abierto, subterránea, perforación y voladura, equipos de 400 toneladas y planificación digital. Con cálculos reales de stripping ratio, voladura y dimensionamiento de flota.',
    desc: 'Resultado: Tus alumnos entienden cómo funciona Cerro Negro, Veladero y Josemaría por dentro.\n\nOPEN PIT · SUBTERRÁNEA · VOLADURA · EQUIPOS · FMS · KPIs · JOSEMARÍA · CERRO NEGRO'
  }, {
    id: 4,
    color: 'bg-forest-soft',
    lightColor: 'bg-forest-soft/10',
    borderColor: 'border-forest-soft/20',
    textColor: 'text-forest-soft',
    emoji: '🏭',
    title: 'Procesamiento de Minerales',
    subtitle: 'Trituración, molienda, flotación, lixiviación y balance metalúrgico. Más el proceso completo de producción de carbonato de litio desde los salares argentinos.',
    desc: 'Resultado: Tus alumnos entienden cómo el mineral de la tierra se convierte en el litio que alimenta las baterías del mundo.\n\nFLOTACIÓN · LIXIVIACIÓN · BALANCE METALÚRGICO · LITIO · CAUCHARI-OLAROZ · PROCESAMIENTO'
  }, {
    id: 5,
    color: 'bg-earth-light',
    lightColor: 'bg-earth-light/10',
    borderColor: 'border-earth-light/20',
    textColor: 'text-earth-light',
    emoji: '🛡️',
    title: 'Seguridad, Ambiente y Legislación Minera',
    subtitle: 'Seguridad laboral, EIA, Ley 24.196, Ley 24.585, RIGI 2024, licencia social y casos reales argentinos: Veladero, Navidad y Bajo de la Alumbrera.',
    desc: 'Resultado: Tus alumnos analizan el conflicto minería-ambiente con datos reales, no con prejuicios.\n\nSEGURIDAD LABORAL · EIA · LEY 24.196 · LEY 24.585 · RIGI · VELADERO · LICENCIA SOCIAL',
    badge: '⭐ EL MÁS POPULAR'
  }, {
    id: 6,
    color: 'bg-gold-dark',
    lightColor: 'bg-gold-dark/10',
    borderColor: 'border-gold-dark/20',
    textColor: 'text-gold-dark',
    emoji: '🚀',
    title: 'Innovación y Gestión Minera 2026',
    subtitle: 'Gestión de proyectos, economía minera, digitalización, drones, inteligencia artificial, automatización y la posición estratégica de Argentina en la geopolítica del litio.',
    desc: 'Resultado: Tus alumnos entienden que la Minería 4.0 es el presente del sector y Argentina está en el centro del tablero global.\n\nGESTIÓN DE PROYECTOS · IA MINERA · DRONES · DLE · LITIO GEOPOLÍTICO · JOSEMARÍA · ARGENTINA 2035'
  }];
  return <section className="py-20 bg-base" data-id="element-318">
      <div className="container mx-auto px-4" data-id="element-319">
        <div className="text-center mb-16" data-id="element-320">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-forest/10 text-forest border border-forest/20 font-bold mb-6" data-id="element-321">
            ⛏️ LOS 6 TOMOS
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold text-forest-dark mb-4" data-id="element-322">
            Un tomo por cada dimensión de la Minería Argentina
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-323">
          {tomos.map((tomo, i) => <motion.div key={tomo.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className={`rounded-2xl border border-sand bg-white overflow-hidden shadow-lg hover:shadow-xl hover:border-earth/30 transition-all flex flex-col h-full relative`} data-id="element-324">
              {tomo.badge && <div className="absolute top-0 right-0 bg-gold text-white text-xs font-bold px-3 py-1 rounded-bl-lg z-10" data-id="element-325">
                  {tomo.badge}
                </div>}
              <div className={`bg-sand/30 p-4 border-b border-sand flex items-center gap-3`} data-id="element-326">
                <div className="text-2xl" data-id="element-327">{tomo.emoji}</div>
                <div data-id="element-328">
                  <p className={`text-xs font-bold uppercase tracking-wider text-muted`} data-id="element-329">
                    Tomo {tomo.id}
                  </p>
                  <h3 className="font-bold text-forest-dark text-lg leading-tight" data-id="element-330">
                    {tomo.title}
                  </h3>
                </div>
              </div>
              <div className="p-6 flex-grow flex flex-col" data-id="element-331">
                <p className="font-semibold text-forest-dark mb-3 pb-3 border-b border-sand" data-id="element-332">
                  {tomo.subtitle}
                </p>
                <p className="text-muted text-sm leading-relaxed whitespace-pre-line" data-id="element-333">
                  {tomo.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}